import React from 'react';
import CourseDetail from '../../components/CourseDetail';
import Courses from './Courses';

const CreateWrapper = (props) => (
  <CourseDetail {...props} actionType="create" />
);
const EditWrapper = (props) => <CourseDetail {...props} actionType="edit" />;

const resource = {
  list: Courses,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;
